import { useState, useEffect } from 'react';
import { useTheme } from '@material-ui/core';

const useResponsiveLayout = () => {
  const theme = useTheme();
  const [screenSize, setScreenSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 1200
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({ width: window.innerWidth });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Use Material-UI breakpoint values: xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920
  const isDesktop = screenSize.width >= 1280; // lg breakpoint
  const isMobile = screenSize.width < 960; // below md breakpoint
  const isTablet = screenSize.width >= 960 && screenSize.width < 1280; // between md and lg

  return {
    isDesktop,
    isMobile,
    isTablet,
    // Layout configurations
    shouldShowExportButtonsInTop: !isDesktop,
    shouldShowExportButtonsInBottom: isDesktop,
    // Control group configurations
    controlGroupStyle: {
      paddingBottom: isDesktop ? theme.spacing(2) : 0,
      marginBottom: isDesktop ? theme.spacing(2) : 0,
    },
    // Container configurations
    topRowStyle: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: theme.spacing(5),
      ...(isDesktop && {
        display: 'block',
        height: '100%',
        flex: '1 1 auto',
      }),
    },
  };
};

export default useResponsiveLayout;